import { createI18n } from 'vue-i18n'

// Import main translation files
import enTranslations from './translations/en.json'
import ptTranslations from './translations/pt.json'

// Import individual translation modules
import artifactEn from './translations/en/Artifact-en.json'
import artifactPt from './translations/pt/Artifact-pt.json'
import associationEn from './translations/en/Association-en.json'
import associationPt from './translations/pt/Association-pt.json'
import companyEn from './translations/en/Company-en.json'
import companyPt from './translations/pt/Company-pt.json'
import dataOrganizationEn from './translations/en/DataOrganization-en.json'
import dataOrganizationPt from './translations/pt/DataOrganization-pt.json'
import dashboardEn from './translations/en/Dashboard-en.json'
import dashboardPt from './translations/pt/Dashboard-pt.json'
import entityEn from './translations/en/Entity-en.json'
import entityPt from './translations/pt/Entity-pt.json'
import propertyEn from './translations/en/Property-en.json'
import propertyPt from './translations/pt/Property-pt.json'
import notificationEn from './translations/en/Notification-en.json'
import notificationPt from './translations/pt/Notification-pt.json'
import refEntityEn from './translations/en/RefEntity-en.json'
import refEntityPt from './translations/pt/RefEntity-pt.json'
import refPropertyEn from './translations/en/RefProperty-en.json'
import refPropertyPt from './translations/pt/RefProperty-pt.json'
import runEn from './translations/en/Run-en.json'
import runPt from './translations/pt/Run-pt.json'
import shareEn from './translations/en/Share-en.json'
import sharePt from './translations/pt/Share-pt.json'
import templateEn from './translations/en/Template-en.json'
import templatePt from './translations/pt/Template-pt.json'
import trackingEn from './translations/en/Tracking-en.json'
import trackingPt from './translations/pt/Tracking-pt.json'
import customListEn from './translations/en/CustomList-en.json'
import customListPt from './translations/pt/CustomList-pt.json'
import userEn from './translations/en/User-en.json'
import userPt from './translations/pt/User-pt.json'
import projectEn from './translations/en/Project-en.json'
import projectPt from './translations/pt/Project-pt.json'
import schemaEn from './translations/en/Schema-en.json'
import schemaPt from './translations/pt/Schema-pt.json'
import promptEn from './translations/en/Prompt-en.json'
import promptPt from './translations/pt/Prompt-pt.json'
import sharePlaceEn from './translations/en/SharePlace-en.json'
import publicProfileEn from './translations/en/PublicProfile-en.json'
import publicProfilePt from './translations/pt/PublicProfile-pt.json'
import shareplacePt from './translations/pt/SharePlace-pt.json'
import blockEn from './translations/en/Block-en.json'
import blockPt from './translations/pt/Block-pt.json'
import blockFilterEn from './translations/en/BlockFilter-en.json'
import blockFilterPt from './translations/pt/BlockFilter-pt.json'
import shareTemplateEn from './translations/en/ShareTemplate-en.json'
import shareTemplatePt from './translations/pt/ShareTemplate-pt.json'
import moderateShareEn from './translations/en/ModerateShare-en.json'
import moderateSharePt from './translations/pt/ModerateShare-pt.json'
import specialBlockEn from './translations/en/SpecialBlock-en.json'
import specialBlockPt from './translations/pt/SpecialBlock-pt.json'
import completeRegistrationEn from './translations/en/CompleteRegistration-en.json'
import completeRegistrationPt from './translations/pt/CompleteRegistration-pt.json'
import companyUserEn from './translations/en/CompanyUser-en.json'
import companyUserPt from './translations/pt/CompanyUser-pt.json'

import componentsInputsEn from './translations/en/ComponentsInputs-en.json'
import componentsInputsPt from './translations/pt/ComponentsInputs-pt.json'
import importEn from './translations/en/Import-en.json'
import importPt from './translations/pt/Import-pt.json'
import templateViewEn from './translations/en/TemplateView-en.json'
import templateViewPt from './translations/pt/TemplateView-pt.json'
import socialLoginEn from './translations/en/SocialLogin-en.json'
import socialLoginPt from './translations/pt/SocialLogin-pt.json'
import checkoutEn from './translations/en/Checkout-en.json'
import checkoutPt from './translations/pt/Checkout-pt.json'
import resetPasswordEn from './translations/en/ResetPassword-en.json'
import resetPasswordPt from './translations/pt/ResetPassword-pt.json'
import deleteAccountEn from './translations/en/DeleteAccount-en.json'
import deleteAccountPt from './translations/pt/DeleteAccount-pt.json'

// Create a deep copy function to avoid mutating imported objects
function deepClone(obj: any): any {
  if (obj === null || typeof obj !== 'object') return obj
  if (obj instanceof Date) return new Date(obj.getTime())
  if (obj instanceof Array) return obj.map(item => deepClone(item))
  
  const cloned: any = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      cloned[key] = deepClone(obj[key])
    }
  }
  return cloned
}

// Create working copies of the translation objects
const englishTranslations = deepClone(enTranslations)
const portugueseTranslations = deepClone(ptTranslations)

// Merge individual translation modules
englishTranslations.artifact = artifactEn
portugueseTranslations.artifact = artifactPt
englishTranslations.association = associationEn
portugueseTranslations.association = associationPt
englishTranslations.company = companyEn
portugueseTranslations.company = companyPt
englishTranslations.data_organization = dataOrganizationEn
portugueseTranslations.data_organization = dataOrganizationPt
englishTranslations.dashboard = dashboardEn.dashboard
portugueseTranslations.dashboard = dashboardPt.dashboard
englishTranslations.entity = entityEn
portugueseTranslations.entity = entityPt
englishTranslations.property = propertyEn
portugueseTranslations.property = propertyPt
englishTranslations.notification = notificationEn
portugueseTranslations.notification = notificationPt
englishTranslations.ref_entity = refEntityEn
portugueseTranslations.ref_entity = refEntityPt
englishTranslations.ref_property = refPropertyEn
portugueseTranslations.ref_property = refPropertyPt
englishTranslations.run = runEn
portugueseTranslations.run = runPt
englishTranslations.share = shareEn
portugueseTranslations.share = sharePt
englishTranslations.template = templateEn
portugueseTranslations.template = templatePt
englishTranslations.tracking = trackingEn
portugueseTranslations.tracking = trackingPt
englishTranslations.customList = customListEn
portugueseTranslations.customList = customListPt
englishTranslations.user = userEn
portugueseTranslations.user = userPt
englishTranslations.project = projectEn
portugueseTranslations.project = projectPt
englishTranslations.schema = schemaEn
portugueseTranslations.schema = schemaPt
englishTranslations.prompt = promptEn
portugueseTranslations.prompt = promptPt
englishTranslations.sharePlace = sharePlaceEn
englishTranslations.publicProfile = publicProfileEn
portugueseTranslations.sharePlace = shareplacePt
portugueseTranslations.publicProfile = publicProfilePt
englishTranslations.block = blockEn
portugueseTranslations.block = blockPt
englishTranslations.blockFilter = blockFilterEn
portugueseTranslations.blockFilter = blockFilterPt
englishTranslations.share_template = shareTemplateEn
portugueseTranslations.share_template = shareTemplatePt
englishTranslations.moderate_share = moderateShareEn
portugueseTranslations.moderate_share = moderateSharePt
englishTranslations.specialBlock = specialBlockEn
portugueseTranslations.specialBlock = specialBlockPt
englishTranslations.complete_registration = completeRegistrationEn
portugueseTranslations.complete_registration = completeRegistrationPt
englishTranslations.company_user = companyUserEn
portugueseTranslations.company_user = companyUserPt
englishTranslations.components_inputs = componentsInputsEn
portugueseTranslations.components_inputs = componentsInputsPt
englishTranslations.import = importEn.import
portugueseTranslations.import = importPt.import
englishTranslations.template_view = templateViewEn
portugueseTranslations.template_view = templateViewPt
englishTranslations.social_login = socialLoginEn
portugueseTranslations.social_login = socialLoginPt
englishTranslations.checkout = checkoutEn
portugueseTranslations.checkout = checkoutPt
englishTranslations.reset_password = resetPasswordEn
portugueseTranslations.reset_password = resetPasswordPt
englishTranslations.delete_account = deleteAccountEn
portugueseTranslations.delete_account = deleteAccountPt

const TRANSLATIONS = {
  en: englishTranslations,
  pt: portugueseTranslations,
}

export default createI18n({
  locale: 'en',
  allowComposition: true,
  fallbackLocale: 'en',
  messages: TRANSLATIONS,
  preserveDirectiveContent: false,
})